export default __webpack_public_path__ + "static/icon_hepia-8cc71eede572c1b5076c56157b8dc9a9.png";